import React from 'react'
import Tooltip from '@/components/Tooltip'
import type { SDUIComponentProps } from '@/types/sduiTypes'

const SDUILabel: React.FC<SDUIComponentProps> = ({
    id,
    label,
    text,
    htmlFor,
    className,
}) => {
    const displayText = (label || text || '') as string
    const targetId = (htmlFor || '') as string

    return (
        <Tooltip
            title={displayText}
            placement="top"
            wrapperClass="w-full h-full"
        >
            <label
                id={id}
                htmlFor={targetId}
                className={
                    (className as string) ||
                    'text-xs font-medium text-gray-700 dark:text-gray-200'
                }
                style={{
                    position: 'absolute',
                    inset: 0,
                    display: 'flex',
                    alignItems: 'center',
                    overflow: 'hidden',
                    paddingLeft: 0,
                }}
            >
                <span
                    style={{
                        display: 'block',
                        width: '100%',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                    }}
                >
                    {displayText}
                </span>
            </label>
        </Tooltip>
    )
}

SDUILabel.displayName = 'SDUILabel'

export default SDUILabel
